// Monthly waterfall display mode. ARR re-expresses each month's MRR as an
// annualized run-rate (MRR × 12); MRR shows the raw monthly figure.
//
// Kept in a pure .ts module (not the .tsx columns file) so non-React consumers
// like the Excel export can import the runtime constant without dragging a .tsx
// through their jest transform, which only handles .ts.
export type MonthlyValueMode = 'arr' | 'mrr';
export const MONTHS_PER_YEAR = 12;
